	export enum ServiceTypeEnum {
		Apprise = 1,
		Noah = 2,
		Smtp = 3,
		Worker = 4,
		Sms = 5,
		Sftp = 6,
		ServiceAPI = 7,
		DocumentGenerator = 8,
		SchedulingWidget = 9,
		BusinessCentral = 10,
		TcmTeleHealthAPI = 11,
		TeleHealth = 12,
    EventHub = 15,
    OrderIntegration = 16,
    ExternalApi = 17,
    ERPJob = 19,
    OrderIntegrationJob = 20,
    ExternalApiJob = 21,
    ClaimsJob = 22
	}
